import { v4 as uuidv4 } from 'uuid';

import { aclOptionEnums, aclOptions } from '../../constants/S3UploadConstants';

import { getFileExtension } from '../FileUploaderUtils';
import { getLastSubstringBasedOnChar } from '../StringUtils';

export const getAclTypeBySecurityType = (securityType: string): string => {
  switch (securityType) {
    case aclOptionEnums.private:
      return aclOptions.private;
    default:
      return aclOptions.publicRead;
  }
};

export const getS3UploadedFileName = (
  overrideBucketPath: string,
  extraBucketPath: string,
  file: File,
  fileUploadConfig: any,
  uuid: string
): string => {
  const { bucketPath } = fileUploadConfig;
  const fileExtension = getFileExtension(file.name, file.type);
  const folderPath = overrideBucketPath || bucketPath;
  const s3BucketPath = folderPath + extraBucketPath;

  const updatedFileName = fileExtension
    ? `${uuid}_${new Date().getTime()}.${fileExtension}`
    : `${uuid}_${new Date().getTime()}`;

  const s3FilePath = s3BucketPath + updatedFileName;

  return s3FilePath;
};

export const getS3FileNameWithPrefix =
  (prefix: string) =>
  (
    overrideBucketPath: string,
    extraBucketPath: string,
    file: File,
    fileUploadConfig: any
  ): string => {
    const { bucketPath } = fileUploadConfig;

    const fileExtension = getFileExtension(file.name, file.type);
    const fileName = getLastSubstringBasedOnChar(file.name, '.')[0];
    const sanitizedFileName = fileName.trim().replace(/\s+/g, '_');
    const updatedFileName = `${prefix}/${new Date().getTime()}_${sanitizedFileName}_${uuidv4()}.${fileExtension}`;
    const s3FilePath = bucketPath + updatedFileName;

    return s3FilePath;
  };
